import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import useSeo from './hooks/useSeo';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import DesafiosSection from './components/DesafiosSection';
import TransformacaoSection from './components/TransformacaoSection';
import ModulesSection from './components/ModulesSection';
import ResultadosSection from './components/ResultadosSection';
import PlanosSection from './components/PlanosSection';
import CasosSucessoSection from './components/CasosSucessoSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

const App = () => {
  useSeo('home');
  return (
    <>
      <ToastContainer position="bottom-right" autoClose={5000} />
      <div className="min-h-screen bg-white font-inter">
        <Header />
        <main>
          <HeroSection />
          <TrustBar />
          <DesafiosSection />
          <TransformacaoSection />
          <ModulesSection />
          <ResultadosSection />
          <PlanosSection />
          <CasosSucessoSection />
          <TestimonialsSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default App;
